
// to make the employee with this uId admin 
// Employee Admin , for login constrictions 
export const directorUid = "7069018"; // ← the director's UID

// Hr person 
export const allowedUsers = ["3101178","7069018","5149007","6741188"];

// Accounting person 
export const AccountingUid =["5149007","6741188","7069018"];

// Supervisor not included in attendance part (excluding this uids in filter names ! )
export const SupervisorUid = ["9007", "9005"]; 

//window.location is the address in the browser bar.
// .hostname is just the domain part, with no https://, no port and no path
// .origin is the start of the address: https:// + domain (+ port if there is one)
//window.location.origin is the start of the address in the browser bar, for example https://
// The phone opens the link built from FRONTEND_BASE_URL, 
// so the domain still comes from your backend .env. 
// If you ever change FRONTEND_BASE_URL to a new domain, 
// the frontend follows automatically and no domain is written 
// in the frontend code.
export const DEFAULT_API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5100"
    : window.location.origin;


//* same as attendance util for coloring records 
export const STAMP_MODULE_COLORS = {
  1: "#b71c1c",
  2: "#e65100",
  3: "#0d47a1",
  4: "#2e7d32",
};

export const LEAVE_COLOR = "#4a148c";

export const getStampColor = (mod) => STAMP_MODULE_COLORS[mod] || STAMP_MODULE_COLORS[3];